import { CustomRadioBox, FromButton, ImpactText, OrganizationForm, SubTitle, SubTitleNumber, SubTitleText, WebsiteAddress, YourImpact } from './EditProfileStyle'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { useFormik } from 'formik';
import * as Yup from "yup";
import { MESSAGE } from '../../../utils/message';
import { ImpactProfileFormik } from '../../../utils/types';
import { useSelector,useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { editNonprofitProfileHandler } from '../../../redux/slices/myNonprofit/editnonprofit-slice';

const ImpactProfile = () => {
  const {id}=useParams()
  const dispatch=useDispatch()
  const editNonprofitProfileSlice : any = useSelector((state:any) => state?.editNonprofitProfile);
  const nonprofitProfile : any = useSelector((state:any) => state?.editNonprofitProfile?.data?.results);
 const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      areas:nonprofitProfile?.areas||"",
      population:nonprofitProfile?.population||"",
      programs:nonprofitProfile?.programs||"",
      bens_direct:nonprofitProfile?.bens_direct||"",
      donate_link:nonprofitProfile?.donate_link||"",
      volunteer_link:nonprofitProfile?.volunteer_link||"",
      volunteer:nonprofitProfile?.volunteer||"",
      donate_link_enabled:nonprofitProfile?.donate_link_enabled||false,
      volunteer_link_enabled:nonprofitProfile?.volunteer_link_enabled||false
    },
    onSubmit: (values: ImpactProfileFormik) => {
      if(id){
        dispatch(editNonprofitProfileHandler(id,values) as any)
      }
    },
  })
  return (
    <YourImpact>
    <SubTitle>
      <SubTitleNumber>03</SubTitleNumber>
      <SubTitleText>{MESSAGE.yourImpact} <ImpactText>(Optional)</ImpactText></SubTitleText>
    </SubTitle>
    <OrganizationForm onSubmit={formik.handleSubmit}>
        <Row>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>{MESSAGE.weWorkIn}:</Form.Label>
              <Form.Control
                type="text"
                name="areas"
                value={formik.values.areas}
                onChange={formik.handleChange}
                placeholder="The Mission in San Francisco..."
              />
            </Form.Group>
          </Col>

          <Col sm={12} md={12} lg={6}>
            <Form.Label>{MESSAGE.toHelp}:</Form.Label>
            <Form.Control
                type="text"
                name="bens_direct"
                value={formik.values.bens_direct}
                onChange={formik.handleChange}
                placeholder="The Environment, Young Children..."
              />
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>{MESSAGE.providingPrograms}:</Form.Label>
              <Form.Control
                type="text"
                name="programs"
                value={formik.values.programs}
                onChange={formik.handleChange}
                placeholder="Arts Programs, Legal Aid, Environmental Advocacy on Emissions..."
              />
            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <Form.Group className="input-box">
              <Form.Label>{MESSAGE.directlyHelped}:</Form.Label>
              <Form.Control
                type="text"
                name="population"
                value={formik.values.population}
                onChange={formik.handleChange}
                placeholder="125 Student, 100 Local Agencies..."
              />
            </Form.Group>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <CustomRadioBox>
              <Form.Check aria-label="radio 1" checked={formik.values?.donate_link_enabled} onChange={formik.handleChange} id="donate_link_enabled" />
              <label htmlFor="rad2" className="form-check-label">
              {MESSAGE.directLinkWebsite}
              </label>
            </CustomRadioBox>
            <WebsiteAddress>
              <Form.Group className="input-box">
                <Form.Label>{MESSAGE.websiteDonateButton}</Form.Label>
                <Form.Control  
                  type="text"
                  name="donate_link"
                  disabled={!formik.values.donate_link_enabled}
                  value={formik.values.donate_link}
                  onChange={formik.handleChange} 
                  placeholder="http://" 
                />
                {formik.touched.donate_link && formik.errors.donate_link && (
                <div className="error">
                  <p>{String(formik.errors.donate_link)}</p>
                </div>
              )}
              </Form.Group>
            </WebsiteAddress>
          </Col>
          <Col sm={12} md={12} lg={6}></Col>
          <Col sm={12} md={12} lg={6}>
            <CustomRadioBox>
              <Form.Check aria-label="radio 1" id="volunteer_link_enabled" onChange={formik.handleChange} checked={formik.values.volunteer_link_enabled} />
              <label htmlFor="rad2" className="form-check-label">
             {MESSAGE.volunteerLink}
              </label>
            </CustomRadioBox>
            <WebsiteAddress>
              <Form.Group className="input-box">
                <Form.Label>Website address for Volunteer button</Form.Label>
                <Form.Control  
                  type="text"
                  disabled={!formik.values.volunteer_link_enabled}
                  name="volunteer_link"
                  value={formik.values.volunteer_link}
                  onChange={formik.handleChange} 
                  placeholder="http://" 
                />
                {formik.touched.volunteer_link && formik.errors.volunteer_link && (
                <div className="error">
                  <p>{String(formik.errors.volunteer_link)}</p>
                </div>
              )}
              </Form.Group>
              <Form.Group className="input-box">
                <Form.Label>{MESSAGE.someoneVolunteer}:</Form.Label>
                <Form.Control 
                  type="text"
                  name="volunteer"
                  disabled={!formik.values.volunteer_link_enabled}
                  value={formik.values.volunteer}
                  onChange={formik.handleChange} 
                  placeholder="i.e. Send Out Newsletters, Post Social Media" 
                 />
                 {formik.touched.volunteer && formik.errors.volunteer && (
                <div className="error">
                  <p>{String(formik.errors.volunteer)}</p>
                </div>
              )}
              </Form.Group>
            </WebsiteAddress>
          </Col>
          <FromButton>
            <Button className="btn-outline-success-blue" type='submit'>
              {MESSAGE.saveChanges}
              {editNonprofitProfileSlice?.isLoading && <span className="btnloader"></span>}
            </Button>
          </FromButton>
        </Row>
    </OrganizationForm>
  </YourImpact>
  )
}

export default ImpactProfile
